import React, { useState, useMemo, useCallback } from "react";
import s from "./styles/profile.module.css";
import { Badge, Calendar, ConfigProvider, Popover, Tag } from "antd";
import locale from "antd/lib/locale/ru_RU";
import ModalReports from "./ModalReports";
import moment from "moment";

const ObjectReports = (props) => {


    console.log(props);

    const [previewElem, setPreviewElem] = useState({ visible: false, elem: {} });
    const [time, setTime] = useState({
        month: moment().format('MMMM'),
        year: moment().format('YYYY '),
        m: moment().format('M '),
    });

    // Мемоизированные функции
    const getObjectNameById = useCallback((id) => {
        const object = props.objects.find(el => Number(el.id) === Number(id));
        return object ? object.name : '';
    }, [props.objects]);

    const setHours = useCallback((start, end) => {
        const formatTime = (timestamp) => {
            const date = new Date(Number(timestamp) * 1000);
            const hours = date.getHours().toString().padStart(2, '0');
            const minutes = date.getMinutes().toString().padStart(2, '0');
            return `${hours}:${minutes}`;
        };

        return `${formatTime(start)} - ${formatTime(end)}`;
    }, []);

    const handlePreviewReport = useCallback((report) => {
        const t_start = moment(Number(report.time_plan) * 1000).startOf('day').format('X');
        const t_end = moment(Number(report.time_plan) * 1000).endOf('day').format('X');

        setPreviewElem({ visible: true, elem: report });
        props.getLinks(Number(report.object_id), Number(t_start), Number(t_end));
    }, [props.getLinks]);

    const handleTimeChange = useCallback((date) => {
        const startTime = moment(date).startOf('month').subtract(1, 'month').format('X');
        const endTime = moment(date).endOf('month').add(1, 'month').format('X');

        setTime({
            month: date.format('MMMM'),
            year: date.format('YYYY '),
            m: date.format('M'),
        });

        props.getReports(Number(startTime), Number(endTime));
    }, [props.getReports]);

    const disabledDate = useCallback((current) => {
        return +current.format('M') !== +time.m;
    }, [time.m]);

    // Функция для рендеринга ячеек календаря
    const cellRender = useCallback((current, info) => {
        if (info.type === 'date') {
            const listData = props.data
                .filter(el => {
                    const planDate = new Date(Number(el.time_plan) * 1000);
                    return planDate.getDate() === current.date() &&
                        planDate.getMonth() + 1 === Number(current.format('M')) &&
                        planDate.getFullYear() === Number(current.format('YYYY'));
                })
                .map((el, index) => {
                    const content = (
                        <div className={s.change__popover}>
                            <Tag className={s.change__popover__read}>
                                {setHours(el.time_start, el.time_end)}
                            </Tag>
                        </div>
                    );

                    return {
                        type: Number(el.time_start) === 0 ? 'error' : 'success',
                        key: `${el.id}-${index}`,
                        content: (
                            <Popover content={content} title="">
                                <div
                                    className={s.report_calendar_item_all}
                                    onClick={() => handlePreviewReport(el)}
                                >
                                    {getObjectNameById(el.object_id)}
                                </div>
                            </Popover>
                        )
                    };
                });

            return (
                <ul className="events">
                    {listData.map(item => (
                        <li key={item.key}>
                            <Badge style={{width: '100%'}} status={item.type} text={item.content} />
                        </li>
                    ))}
                </ul>
            );
        }
        return null;
    }, [props.data, setHours, handlePreviewReport, getObjectNameById]);

    const handleCloseModal = useCallback(() => {
        setPreviewElem(prev => ({ ...prev, visible: false }));
    }, []);

    return (
        <>
            <div className={s.report__title}>Обслуживание объектов</div>
            <ConfigProvider locale={locale}>
                <Calendar
                    className={s.calendar_all}
                    cellRender={cellRender}
                    onPanelChange={handleTimeChange}
                    disabledDate={disabledDate}
                />
            </ConfigProvider>

            {previewElem.visible && (
                <ModalReports
                    title={getObjectNameById(previewElem.elem.object_id)}
                    links={props.links}
                    elem={previewElem.elem}
                    template={props.template}
                    close={handleCloseModal}
                />
            )}
        </>
    );
};

export default React.memo(ObjectReports);